import { Tag } from '@dev-spendesk/grapes';
import React from 'react';

interface Props {
  onToggleGringottsIframe: () => void;
}

export const GringottsProfileItem = ({ onToggleGringottsIframe }: Props) => {
  return (
    <button
      type="button"
      className="bg-background-primary-default body-m hover:bg-background-primary-hover w-full cursor-pointer border-none text-left"
      onClick={onToggleGringottsIframe}
    >
      Console
      <Tag className="ml-8" variant="purple">
        Demo
      </Tag>
    </button>
  );
};
